package com.marcinmoskala.albert.presentation.ui.learning.components

import androidx.compose.ui.graphics.Color

internal val CorrectContainerGreen = Color(0xFF1B5E20)
internal val CorrectHighlightGreen = Color(0xFF2E7D32)
internal val OnCorrectContainerGreen = Color(0xFFDFF6E3)